import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/profile.png";
import { createSelector } from 'reselect';
import { useNavigate } from 'react-router-dom';
import { Constant } from 'utils/enums';
import { handleLogout } from 'helpers/api_helper';
import Logoutmodal from '../Common/confirmation-logout-modal'

const ProfileDropdown = () => {

    const profiledropdownData = createSelector(
        (state: any) => state.Profile!,
        (user) => user?.user
    );
    // Inside your component
    const user = useSelector(profiledropdownData);


    const selectsellerProfile = createSelector(
        (state: any) => state.Business,
        (business) => business?.business
    );
    const seller = useSelector(selectsellerProfile);

    useEffect(() => {
    }, [seller]);


    const [userName, setUserName] = useState("");
    const [islogout, setislogout] = useState<boolean>(false);



    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user,
    );

    const userInfo = useSelector(selectUser)

    useEffect(() => {
        const authUser = sessionStorage.getItem("user");
        if (authUser) {
            const obj = JSON.parse(authUser);
            const nameFromAuth = obj.name || obj.given_name || obj.email;
            setUserName(nameFromAuth || "Admin");
        }
    }, [user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState<boolean>(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>

            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none" data-testing-id="accountDropDown_ProfileDropdown">
                    <span className="d-flex align-items-center">
                        <img
                            className="rounded-circle header-profile-user"
                            src={seller?.shopLogo?.url || avatar1}
                            alt="Header Avatar"
                        />
                        <span className="text-start ms-xl-2">
                            <span
                                className="d-none d-xl-inline-block ms-1 fw-medium user-name-text truncate-text text-overflow"
                                style={{ maxWidth: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}

                            >
                                {seller?.firstName || seller?.fullName}
                            </span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text"></span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                    <h6 className="dropdown-header">Welcome {seller?.firstName || seller?.fullName}</h6>
                    <DropdownItem href={process.env.PUBLIC_URL + "/my-account-setting"}><i
                        className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Account Settings</span></DropdownItem>
                    <DropdownItem onClick={() => setislogout(true)}
                        data-testing-id="logoutButton_ProfileDropDown"><i
                            className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle" data-key="t-logout">Logout</span>
                                <Logoutmodal
                        show={islogout}
                        onCloseClick={() => setislogout(false)}
                      />
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;